export const businessServices = [
  { name: 'Agriculture', icon: '🌱' },
  { name: 'App And Web Development', icon: '💻' },
  { name: 'Astrologer', icon: '🔮' },
  { name: 'Automobile', icon: '🚗' },
  { name: 'Automobile Accessories', icon: '🚙' },
  { name: 'Babycare', icon: '👶' },
  { name: 'Books & Stationary', icon: '📚' },
  { name: 'Business Development', icon: '📊' },
  { name: 'Cabs & Taxi', icon: '🚕' },
  { name: 'Cafe', icon: '☕' },
  { name: 'Caterer', icon: '🍽️' },
  { name: 'Celebrity', icon: '⭐' },
  { name: 'Chemist', icon: '💊' },
  { name: 'Computer & It', icon: '💻' },
  { name: 'Construction Material', icon: '🏗️' },
  { name: 'Contractors', icon: '👷' },
  { name: 'Cosmetics', icon: '💄' },
  { name: 'Couriers', icon: '📦' },
  { name: 'Csc & Cyber Cafe', icon: '🖱️' },
  { name: 'Decorators', icon: '🎨' },
  { name: 'Diagnostic Center', icon: '🔬' },
  { name: 'Digital Marketing', icon: '📱' },
  { name: 'Doctor', icon: '👨‍⚕️' },
  { name: 'Driving School', icon: '🚗' },
  { name: 'Education', icon: '📖' },
  { name: 'Electric & Electronics', icon: '⚡' },
  { name: 'Emergency', icon: '🚨' },
  { name: 'Entertainments', icon: '🎬' },
  { name: 'Event Organizer', icon: '📅' },
  { name: 'Financial Consultant', icon: '💰' },
  { name: 'Fitness & Gym', icon: '🏋️' },
  { name: 'Flower & Nursery', icon: '🌸' },
  { name: 'Footwear', icon: '👟' },
  { name: 'Furniture', icon: '🛋️' },
  { name: 'Garments', icon: '👕' },
  { name: 'Gifts', icon: '🎁' },
  { name: 'Grocery And General Store', icon: '🛒' },
  { name: 'Hardware & Machinery', icon: '🔧' },
  { name: 'Health & Beauty', icon: '💅' },
  { name: 'Herbal Haven', icon: '🌿' },
  { name: 'Hobbies', icon: '🎵' },
  { name: 'Home Décor', icon: '🏠' },
  { name: 'Hospitals', icon: '🏥' },
  { name: 'Hotel', icon: '🏨' },
  { name: 'House Keeping', icon: '🧹' },
  { name: 'Human Resource', icon: '👥' },
  { name: 'Industrial Product', icon: '🏭' },
  { name: 'Influencer Creator', icon: '⭐' },
  { name: 'Insurance', icon: '🛡️' },
  { name: 'Internet Provider', icon: '🌐' },
  { name: 'Jewellery & Gemstones', icon: '💎' },
  { name: 'Laboratory Equipment', icon: '🔬' },
  { name: 'Laundry', icon: '🧺' },
  { name: 'Loan', icon: '💰' },
  { name: 'Malls', icon: '🏬' },
  { name: 'Matrimonial', icon: '💑' },
  { name: 'Milk & Milk Products', icon: '🥛' },
  { name: 'Mobile', icon: '📱' },
  { name: 'Modular Kitchen', icon: '🍳' },
  { name: 'News Paper', icon: '📰' },
  { name: 'Ngo', icon: '🏛️' },
  { name: 'Nursing Services', icon: '👩‍⚕️' },
  { name: 'Optical Shop', icon: '👓' },
  { name: 'Others', icon: '📋' },
  { name: 'Packers & Movers', icon: '📦' },
  { name: 'Paints Shop', icon: '🎨' },
  { name: 'Pandit', icon: '🙏' },
  { name: 'Pest Control', icon: '🐛' },
  { name: 'Pet & Pets Care', icon: '🐕' },
  { name: 'Pg & Hostel', icon: '🏠' },
  { name: 'Photo Studio', icon: '📷' },
  { name: 'Placement Services', icon: '💼' },
  { name: 'Play School', icon: '🎨' },
  { name: 'Politician', icon: '🎤' },
  { name: 'Press & Media', icon: '📰' },
  { name: 'Printing Press', icon: '🖨️' },
  { name: 'Real Estate', icon: '🏢' },
  { name: 'Rent & Hire', icon: '🤝' },
  { name: 'Repair & Services', icon: '🔧' },
  { name: 'Restaurant And Dhaba', icon: '🍽️' },
  { name: 'Ro Water', icon: '💧' },
  { name: 'Salon & Spa', icon: '💇' },
  { name: 'Sanitary & Plumbing', icon: '🚰' },
  { name: 'Scrap Buyers', icon: '♻️' },
  { name: 'Scrap Dealers', icon: '♻️' },
  { name: 'Security Service', icon: '👮' },
  { name: 'Sewing Machine', icon: '🧵' },
  { name: 'Skilled Professional', icon: '👨‍🔧' },
  { name: 'Solar Shop', icon: '☀️' },
  { name: 'Sports & Indoor', icon: '⚽' },
  { name: 'Street Vendor', icon: '🛒' },
  { name: 'Sweet Shop', icon: '🍬' },
  { name: 'Tailor', icon: '👗' },
  { name: 'Tiles & Marble', icon: '🏗️' },
  { name: 'Timber Shop', icon: '🪵' },
  { name: 'Tour & Travel', icon: '✈️' },
  { name: 'Toy Store', icon: '🧸' },
  { name: 'Transportation', icon: '🚚' },
  { name: 'Utensils Shop', icon: '🍴' },
  { name: 'Vegetables And Fruits', icon: '🥬' },
  { name: 'Visa Assistance', icon: '🛂' },
  { name: 'Vocational Training', icon: '📚' },
  { name: 'Watch', icon: '⌚' },
  { name: 'Water Tanker', icon: '🚰' },
  { name: 'Wedding', icon: '💒' },
  { name: 'Yoga & Meditation', icon: '🧘' },
];

export const professionalServices = [
  { name: 'Automotive Technician', icon: '🔧' },
  { name: 'Beautician', icon: '💄' },
  { name: 'Carpenter', icon: '🪚' },
  { name: 'Chef', icon: '👨‍🍳' },
  { name: 'Civil Work', icon: '👷' },
  { name: 'Driver', icon: '🚗' },
  { name: 'Electrician', icon: '⚡' },
  { name: 'First Aid Team', icon: '🚑' },
  { name: 'Home Appliance Repair', icon: '🔧' },
  { name: 'House Keeper', icon: '🧹' },
  { name: 'Key Maker', icon: '🔑' },
  { name: 'Mason', icon: '🧱' },
  { name: 'Painter', icon: '🎨' },
  { name: 'Photographer', icon: '📸' },
  { name: 'Plumber', icon: '🔧' },
  { name: 'Solar Pv Technician', icon: '☀️' },
  { name: 'Tailor', icon: '👗' },
  { name: 'Towing Service', icon: '🚛' },
];

export const dailyNeeds = [
  { name: 'Automobile', icon: '🚗' },
  { name: 'Education', icon: '📖' },
  { name: 'Grocery & General Store', icon: '🛒' },
  { name: 'Hotel', icon: '🏨' },
  { name: 'Jewellery', icon: '💎' },
  { name: 'Mobile', icon: '📱' },
  { name: 'Restaurant', icon: '🍽️' },
  { name: 'Vegetable & Fruits', icon: '🥬' },
];

export const exploreMore = [
  { title: 'Real Estate', icon: '🏠', tag: 'Properties', colors: ['#667eea', '#764ba2'], filter: 'Real Estate' },
  { title: 'Digital Marketing', icon: '📣', tag: 'Marketing', colors: ['#f093fb', '#f5576c'], filter: 'Digital Marketing' },
  { title: 'Doctor Consult', icon: '🩺', tag: 'Health', colors: ['#4facfe', '#00f2fe'], filter: 'Doctor' },
  { title: 'Rent & Hire', icon: '🤝', tag: 'Services', colors: ['#43e97b', '#38f9d7'], filter: 'Rent & Hire' },
  { title: 'Tour & Travel', icon: '✈️', tag: 'Travel', colors: ['#fa709a', '#fee140'], filter: 'Tour & Travel' },
];

export const subCategories = {
  'Agriculture': [
    { name: 'Agricultural & Gardening Tool', icon: '🌿' },
    { name: 'Agricultural Pesticides', icon: '🧑‍🌾' },
    { name: 'Agriculture Machinery', icon: '🚜' },
    { name: 'Animal Feed', icon: '🌾' },
    { name: 'Farm Animal Accessories', icon: '🐄' },
    { name: 'Fertilizer', icon: '🪣' },
    { name: 'Millet Seed', icon: '🌰' },
    { name: 'Pesticides', icon: '🧪' },
    { name: 'Plants & Trees', icon: '🌳' },
    { name: 'Seeds & Saplings', icon: '🌱' },
  ],
  'App And Web Development': [
    { name: 'Android App Development', icon: '📱' },
    { name: 'iOS App Development', icon: '🍎' },
    { name: 'Web Design', icon: '🎨' },
    { name: 'Web Development', icon: '💻' },
    { name: 'E-Commerce Development', icon: '🛒' },
    { name: 'UI/UX Design', icon: '✏️' },
    { name: 'SEO Services', icon: '🔍' },
    { name: 'Domain & Hosting', icon: '🌐' },
  ],
  'Automobile': [
    { name: 'Car Dealer', icon: '🚗' },
    { name: 'Bike Dealer', icon: '🏍️' },
    { name: 'Auto Repair', icon: '🔧' },
    { name: 'Car Wash', icon: '🚿' },
    { name: 'Tyre Shop', icon: '🔄' },
    { name: 'Battery Shop', icon: '🔋' },
    { name: 'Spare Parts', icon: '⚙️' },
    { name: 'Truck & Commercial', icon: '🚛' },
  ],
  'Automobile Accessories': [
    { name: 'Car Accessories', icon: '🚗' },
    { name: 'Bike Accessories', icon: '🏍️' },
    { name: 'Car Seat Covers', icon: '💺' },
    { name: 'Car Audio & Video', icon: '🔊' },
    { name: 'GPS & Navigation', icon: '📍' },
    { name: 'Car Care Products', icon: '✨' },
  ],
  'Babycare': [
    { name: 'Baby Clothing', icon: '👶' },
    { name: 'Baby Food', icon: '🍼' },
    { name: 'Baby Toys', icon: '🧸' },
    { name: 'Baby Furniture', icon: '🛏️' },
    { name: 'Baby Healthcare', icon: '💊' },
    { name: 'Diapers & Wipes', icon: '🧻' },
  ],
  'Books & Stationary': [
    { name: 'Books', icon: '📚' },
    { name: 'Stationery', icon: '✏️' },
    { name: 'Art Supplies', icon: '🎨' },
    { name: 'Office Supplies', icon: '📎' },
    { name: 'School Supplies', icon: '🎒' },
    { name: 'Gift & Wrapping', icon: '🎁' },
  ],
  'Cafe': [
    { name: 'Coffee Shop', icon: '☕' },
    { name: 'Tea Stall', icon: '🍵' },
    { name: 'Bakery Cafe', icon: '🥐' },
    { name: 'Juice Bar', icon: '🥤' },
    { name: 'Ice Cream Parlour', icon: '🍦' },
    { name: 'Fast Food Cafe', icon: '🍔' },
  ],
  'Caterer': [
    { name: 'Wedding Catering', icon: '💒' },
    { name: 'Corporate Catering', icon: '🏢' },
    { name: 'Home Catering', icon: '🏠' },
    { name: 'Tiffin Service', icon: '🍱' },
    { name: 'Party Catering', icon: '🎉' },
    { name: 'Veg Catering', icon: '🥗' },
    { name: 'Non-Veg Catering', icon: '🍗' },
  ],
  'Chemist': [
    { name: 'Medical Store', icon: '💊' },
    { name: 'Ayurvedic Store', icon: '🌿' },
    { name: 'Homeopathy', icon: '🧴' },
    { name: 'Surgical Items', icon: '🩺' },
    { name: 'Veterinary Medicine', icon: '🐾' },
  ],
  'Computer & It': [
    { name: 'Computer Sales', icon: '🖥️' },
    { name: 'Laptop Repair', icon: '💻' },
    { name: 'Networking', icon: '🌐' },
    { name: 'CCTV Installation', icon: '📷' },
    { name: 'Software Solutions', icon: '💾' },
    { name: 'IT Consulting', icon: '👨‍💻' },
    { name: 'Printer & Cartridge', icon: '🖨️' },
  ],
  'Construction Material': [
    { name: 'Cement', icon: '🏗️' },
    { name: 'Bricks & Blocks', icon: '🧱' },
    { name: 'Steel & Iron', icon: '⚙️' },
    { name: 'Sand & Gravel', icon: '🪨' },
    { name: 'Tiles & Flooring', icon: '🔲' },
    { name: 'Paints', icon: '🎨' },
    { name: 'Plywood & Timber', icon: '🪵' },
    { name: 'Pipes & Fittings', icon: '🔧' },
  ],
  'Cosmetics': [
    { name: 'Skincare', icon: '✨' },
    { name: 'Makeup', icon: '💄' },
    { name: 'Haircare', icon: '💇' },
    { name: 'Perfumes', icon: '🌸' },
    { name: 'Nail Care', icon: '💅' },
    { name: 'Men Grooming', icon: '🧔' },
  ],
  'Decorators': [
    { name: 'Wedding Decoration', icon: '💒' },
    { name: 'Birthday Decoration', icon: '🎂' },
    { name: 'Event Decoration', icon: '🎉' },
    { name: 'Balloon Decoration', icon: '🎈' },
    { name: 'Floral Decoration', icon: '🌸' },
    { name: 'Stage Decoration', icon: '🎭' },
  ],
  'Digital Marketing': [
    { name: 'Social Media Marketing', icon: '📱' },
    { name: 'SEO', icon: '🔍' },
    { name: 'Google Ads', icon: '📢' },
    { name: 'Content Writing', icon: '✍️' },
    { name: 'Email Marketing', icon: '📧' },
    { name: 'Video Marketing', icon: '🎬' },
    { name: 'Influencer Marketing', icon: '⭐' },
  ],
  'Doctor': [
    { name: 'General Physician', icon: '👨‍⚕️' },
    { name: 'Dentist', icon: '🦷' },
    { name: 'Eye Specialist', icon: '👁️' },
    { name: 'Skin Specialist', icon: '🩺' },
    { name: 'Orthopedic', icon: '🦴' },
    { name: 'Gynecologist', icon: '👩‍⚕️' },
    { name: 'Pediatrician', icon: '👶' },
    { name: 'Cardiologist', icon: '❤️' },
    { name: 'Neurologist', icon: '🧠' },
    { name: 'Psychiatrist', icon: '🧘' },
  ],
  'Education': [
    { name: 'School', icon: '🏫' },
    { name: 'College', icon: '🎓' },
    { name: 'Coaching Center', icon: '📖' },
    { name: 'Tuition', icon: '✏️' },
    { name: 'Skill Training', icon: '🛠️' },
    { name: 'Online Classes', icon: '💻' },
    { name: 'Language Classes', icon: '🗣️' },
    { name: 'Music Classes', icon: '🎵' },
    { name: 'Dance Classes', icon: '💃' },
    { name: 'Sports Academy', icon: '⚽' },
  ],
  'Electric & Electronics': [
    { name: 'Electrical Shop', icon: '⚡' },
    { name: 'Electronics Store', icon: '📺' },
    { name: 'AC & Refrigerator', icon: '❄️' },
    { name: 'Washing Machine', icon: '🫧' },
    { name: 'LED & Lighting', icon: '💡' },
    { name: 'Wiring & Fitting', icon: '🔌' },
    { name: 'Solar Products', icon: '☀️' },
  ],
  'Event Organizer': [
    { name: 'Wedding Planner', icon: '💒' },
    { name: 'Birthday Party', icon: '🎂' },
    { name: 'Corporate Events', icon: '🏢' },
    { name: 'Concert & Shows', icon: '🎤' },
    { name: 'Exhibition', icon: '🖼️' },
    { name: 'Conference', icon: '📊' },
  ],
  'Financial Consultant': [
    { name: 'Tax Consultant', icon: '📋' },
    { name: 'CA Services', icon: '💼' },
    { name: 'Investment Advisor', icon: '📈' },
    { name: 'Insurance Advisor', icon: '🛡️' },
    { name: 'Loan Consultant', icon: '💰' },
    { name: 'Accounting', icon: '🧾' },
  ],
  'Fitness & Gym': [
    { name: 'Gym', icon: '🏋️' },
    { name: 'Yoga Center', icon: '🧘' },
    { name: 'Zumba Classes', icon: '💃' },
    { name: 'CrossFit', icon: '🏃' },
    { name: 'Martial Arts', icon: '🥋' },
    { name: 'Swimming Pool', icon: '🏊' },
    { name: 'Sports Club', icon: '⚽' },
  ],
  'Furniture': [
    { name: 'Home Furniture', icon: '🛋️' },
    { name: 'Office Furniture', icon: '🪑' },
    { name: 'Modular Furniture', icon: '🗄️' },
    { name: 'Wooden Furniture', icon: '🪵' },
    { name: 'Steel Furniture', icon: '⚙️' },
    { name: 'Kids Furniture', icon: '🧸' },
    { name: 'Antique Furniture', icon: '🏺' },
  ],
  'Garments': [
    { name: 'Men Clothing', icon: '👔' },
    { name: 'Women Clothing', icon: '👗' },
    { name: 'Kids Clothing', icon: '👶' },
    { name: 'Ethnic Wear', icon: '🥻' },
    { name: 'Sports Wear', icon: '🏃' },
    { name: 'Winter Wear', icon: '🧥' },
    { name: 'Undergarments', icon: '👕' },
  ],
  'Grocery And General Store': [
    { name: 'Grocery Store', icon: '🛒' },
    { name: 'Supermarket', icon: '🏬' },
    { name: 'Organic Store', icon: '🌿' },
    { name: 'Dry Fruits', icon: '🥜' },
    { name: 'Spices & Masala', icon: '🌶️' },
    { name: 'Dairy Products', icon: '🥛' },
    { name: 'Bakery Items', icon: '🍞' },
  ],
  'Hardware & Machinery': [
    { name: 'Hardware Store', icon: '🔧' },
    { name: 'Power Tools', icon: '🔨' },
    { name: 'Industrial Machinery', icon: '⚙️' },
    { name: 'Pumps & Motors', icon: '💧' },
    { name: 'Welding Equipment', icon: '🔥' },
    { name: 'Safety Equipment', icon: '🦺' },
  ],
  'Health & Beauty': [
    { name: 'Beauty Parlour', icon: '💅' },
    { name: 'Salon', icon: '💇' },
    { name: 'Spa', icon: '🧖' },
    { name: 'Makeup Artist', icon: '💄' },
    { name: 'Mehndi Artist', icon: '🌸' },
    { name: 'Tattoo Studio', icon: '🎨' },
  ],
  'Hospitals': [
    { name: 'Multi Specialty Hospital', icon: '🏥' },
    { name: 'Nursing Home', icon: '🏠' },
    { name: 'Clinic', icon: '🩺' },
    { name: 'Diagnostic Lab', icon: '🔬' },
    { name: 'Blood Bank', icon: '🩸' },
    { name: 'Ambulance Service', icon: '🚑' },
    { name: 'Pharmacy', icon: '💊' },
  ],
  'Hotel': [
    { name: 'Budget Hotel', icon: '🏨' },
    { name: 'Luxury Hotel', icon: '🌟' },
    { name: 'Resort', icon: '🏖️' },
    { name: 'Guest House', icon: '🏡' },
    { name: 'Homestay', icon: '🏠' },
    { name: 'Hostel', icon: '🛏️' },
  ],
  'Jewellery & Gemstones': [
    { name: 'Gold Jewellery', icon: '💛' },
    { name: 'Silver Jewellery', icon: '⚪' },
    { name: 'Diamond Jewellery', icon: '💎' },
    { name: 'Artificial Jewellery', icon: '📿' },
    { name: 'Gemstones', icon: '💠' },
    { name: 'Watches', icon: '⌚' },
  ],
  'Real Estate': [
    { name: 'Residential Property', icon: '🏠' },
    { name: 'Commercial Property', icon: '🏢' },
    { name: 'Plot & Land', icon: '🗺️' },
    { name: 'Rental Property', icon: '🔑' },
    { name: 'Property Dealer', icon: '🤝' },
    { name: 'Interior Designer', icon: '🎨' },
    { name: 'Architect', icon: '📐' },
  ],
  'Restaurant And Dhaba': [
    { name: 'Veg Restaurant', icon: '🥗' },
    { name: 'Non-Veg Restaurant', icon: '🍗' },
    { name: 'Dhaba', icon: '🍛' },
    { name: 'Fast Food', icon: '🍔' },
    { name: 'Chinese Food', icon: '🍜' },
    { name: 'Pizza & Pasta', icon: '🍕' },
    { name: 'South Indian', icon: '🍚' },
    { name: 'Sweets & Snacks', icon: '🍬' },
  ],
  'Salon & Spa': [
    { name: 'Hair Salon', icon: '💇' },
    { name: 'Unisex Salon', icon: '✂️' },
    { name: 'Spa & Massage', icon: '🧖' },
    { name: 'Nail Studio', icon: '💅' },
    { name: 'Bridal Makeup', icon: '👰' },
    { name: 'Threading & Waxing', icon: '🌸' },
  ],
  'Tour & Travel': [
    { name: 'Travel Agency', icon: '✈️' },
    { name: 'Tour Packages', icon: '🗺️' },
    { name: 'Cab Service', icon: '🚕' },
    { name: 'Bus Booking', icon: '🚌' },
    { name: 'Hotel Booking', icon: '🏨' },
    { name: 'Visa Services', icon: '🛂' },
    { name: 'Honeymoon Packages', icon: '💑' },
  ],
  'Wedding': [
    { name: 'Wedding Planner', icon: '💒' },
    { name: 'Wedding Venue', icon: '🏛️' },
    { name: 'Wedding Photographer', icon: '📷' },
    { name: 'Wedding Catering', icon: '🍽️' },
    { name: 'Bridal Wear', icon: '👰' },
    { name: 'Wedding Decoration', icon: '🌸' },
    { name: 'Wedding Card', icon: '💌' },
    { name: 'DJ & Music', icon: '🎵' },
  ],
  'Rent & Hire': [
    { name: 'Car On Rent', icon: '🚗' },
    { name: 'Bike On Rent', icon: '🏍️' },
    { name: 'House On Rent', icon: '🏠' },
    { name: 'Furniture On Rent', icon: '🛋️' },
    { name: 'AC On Rent', icon: '❄️' },
    { name: 'Bus On Rent', icon: '🚌' },
    { name: 'Tent On Rent', icon: '⛺' },
    { name: 'Equipment On Rent', icon: '🔧' },
  ],
  'Packers & Movers': [
    { name: 'Home Shifting', icon: '🏠' },
    { name: 'Office Shifting', icon: '🏢' },
    { name: 'Vehicle Transport', icon: '🚗' },
    { name: 'Warehouse Storage', icon: '🏭' },
    { name: 'International Moving', icon: '✈️' },
  ],
  'Pet & Pets Care': [
    { name: 'Pet Shop', icon: '🐕' },
    { name: 'Veterinary Doctor', icon: '🩺' },
    { name: 'Pet Grooming', icon: '✂️' },
    { name: 'Pet Food', icon: '🦴' },
    { name: 'Pet Boarding', icon: '🏠' },
    { name: 'Aquarium', icon: '🐠' },
  ],
  'Business Development': [
    { name: 'Business Consultant', icon: '💼' },
    { name: 'Startup Consultant', icon: '🚀' },
    { name: 'Marketing Consultant', icon: '📊' },
    { name: 'Legal Consultant', icon: '⚖️' },
    { name: 'HR Consultant', icon: '👥' },
    { name: 'IT Consultant', icon: '💻' },
  ],
  'Mobile': [
    { name: 'Mobile Phones', icon: '📱' },
    { name: 'Mobile Repair', icon: '🔧' },
    { name: 'Mobile Accessories', icon: '🎧' },
    { name: 'Second Hand Mobile', icon: '♻️' },
    { name: 'SIM Card', icon: '📶' },
    { name: 'Mobile Cover & Screen Guard', icon: '🛡️' },
  ],
  'Vegetables And Fruits': [
    { name: 'Fresh Vegetables', icon: '🥦' },
    { name: 'Fresh Fruits', icon: '🍎' },
    { name: 'Organic Vegetables', icon: '🌿' },
    { name: 'Exotic Vegetables', icon: '🥑' },
    { name: 'Dry Fruits', icon: '🥜' },
    { name: 'Seasonal Fruits', icon: '🍓' },
  ],
  'Repair & Services': [
    { name: 'AC Repair', icon: '❄️' },
    { name: 'TV Repair', icon: '📺' },
    { name: 'Mobile Repair', icon: '📱' },
    { name: 'Washing Machine Repair', icon: '🫧' },
    { name: 'Refrigerator Repair', icon: '🧊' },
    { name: 'Laptop Repair', icon: '💻' },
    { name: 'Water Purifier Repair', icon: '💧' },
  ],

  // ── Professional Services Subcategories ──
  'Automotive Technician': [
    { name: 'Car Mechanic', icon: '🚗' },
    { name: 'Bike Mechanic', icon: '🏍️' },
    { name: 'Denting & Painting', icon: '🎨' },
    { name: 'AC Repair (Vehicle)', icon: '❄️' },
    { name: 'Tyre Puncture', icon: '🔄' },
    { name: 'Battery Replacement', icon: '🔋' },
  ],
  'Beautician': [
    { name: 'Facial & Cleanup', icon: '✨' },
    { name: 'Waxing', icon: '🌸' },
    { name: 'Threading', icon: '🧵' },
    { name: 'Bridal Makeup', icon: '👰' },
    { name: 'Party Makeup', icon: '💄' },
    { name: 'Hair Styling', icon: '💇' },
    { name: 'Nail Art', icon: '💅' },
    { name: 'Mehndi', icon: '🌿' },
  ],
  'Carpenter': [
    { name: 'Furniture Making', icon: '🛋️' },
    { name: 'Furniture Repair', icon: '🔧' },
    { name: 'Door & Window Fitting', icon: '🚪' },
    { name: 'Modular Kitchen', icon: '🍳' },
    { name: 'Wooden Flooring', icon: '🪵' },
    { name: 'Wardrobe Making', icon: '🗄️' },
  ],
  'Chef': [
    { name: 'Home Cook', icon: '🍳' },
    { name: 'Party Cook', icon: '🎉' },
    { name: 'Wedding Cook', icon: '💒' },
    { name: 'Tiffin Service', icon: '🍱' },
    { name: 'Baking & Pastry', icon: '🎂' },
    { name: 'Continental Chef', icon: '🍝' },
  ],
  'Civil Work': [
    { name: 'House Construction', icon: '🏠' },
    { name: 'Renovation', icon: '🔨' },
    { name: 'Flooring', icon: '🔲' },
    { name: 'Plastering', icon: '🧱' },
    { name: 'Waterproofing', icon: '💧' },
    { name: 'False Ceiling', icon: '🏗️' },
    { name: 'Tiling Work', icon: '🪟' },
  ],
  'Driver': [
    { name: 'Personal Driver', icon: '🚗' },
    { name: 'Cab Driver', icon: '🚕' },
    { name: 'Truck Driver', icon: '🚛' },
    { name: 'Bus Driver', icon: '🚌' },
    { name: 'Tempo Driver', icon: '🚐' },
    { name: 'Outstation Driver', icon: '🛣️' },
  ],
  'Electrician': [
    { name: 'Home Wiring', icon: '🔌' },
    { name: 'Fan Installation', icon: '💨' },
    { name: 'AC Installation', icon: '❄️' },
    { name: 'MCB & Panel Work', icon: '⚡' },
    { name: 'CCTV Installation', icon: '📷' },
    { name: 'Solar Installation', icon: '☀️' },
    { name: 'Inverter & Battery', icon: '🔋' },
  ],
  'First Aid Team': [
    { name: 'Emergency First Aid', icon: '🚑' },
    { name: 'Event Medical Team', icon: '🏥' },
    { name: 'Home Nursing', icon: '👩‍⚕️' },
    { name: 'Patient Care', icon: '🩺' },
    { name: 'Blood Pressure Check', icon: '💉' },
  ],
  'Home Appliance Repair': [
    { name: 'AC Repair', icon: '❄️' },
    { name: 'Refrigerator Repair', icon: '🧊' },
    { name: 'Washing Machine Repair', icon: '🫧' },
    { name: 'TV Repair', icon: '📺' },
    { name: 'Microwave Repair', icon: '📡' },
    { name: 'Water Purifier Repair', icon: '💧' },
    { name: 'Geyser Repair', icon: '🔥' },
  ],
  'House Keeper': [
    { name: 'Daily Cleaning', icon: '🧹' },
    { name: 'Deep Cleaning', icon: '🫧' },
    { name: 'Kitchen Cleaning', icon: '🍳' },
    { name: 'Bathroom Cleaning', icon: '🚿' },
    { name: 'Sofa & Carpet Cleaning', icon: '🛋️' },
    { name: 'Office Cleaning', icon: '🏢' },
    { name: 'Cook & Maid', icon: '👩‍🍳' },
  ],
  'Key Maker': [
    { name: 'Duplicate Key', icon: '🔑' },
    { name: 'Lock Repair', icon: '🔒' },
    { name: 'Lock Opening', icon: '🔓' },
    { name: 'Digital Lock', icon: '🖥️' },
    { name: 'Car Key', icon: '🚗' },
    { name: 'Safe Lock', icon: '🗄️' },
  ],
  'Mason': [
    { name: 'Brick Work', icon: '🧱' },
    { name: 'Plastering', icon: '🏗️' },
    { name: 'Tiling', icon: '🔲' },
    { name: 'Concrete Work', icon: '⚙️' },
    { name: 'Wall Repair', icon: '🔨' },
    { name: 'Boundary Wall', icon: '🏠' },
  ],
  'Painter': [
    { name: 'Interior Painting', icon: '🎨' },
    { name: 'Exterior Painting', icon: '🏠' },
    { name: 'Texture Painting', icon: '✨' },
    { name: 'Waterproofing Paint', icon: '💧' },
    { name: 'Wood Polish', icon: '🪵' },
    { name: 'Wall Putty', icon: '🖌️' },
  ],
  'Photographer': [
    { name: 'Wedding Photography', icon: '💒' },
    { name: 'Birthday Photography', icon: '🎂' },
    { name: 'Product Photography', icon: '📦' },
    { name: 'Portrait Photography', icon: '🤳' },
    { name: 'Videography', icon: '🎬' },
    { name: 'Drone Photography', icon: '🚁' },
    { name: 'Photo Editing', icon: '🖼️' },
  ],
  'Plumber': [
    { name: 'Pipe Fitting', icon: '🔧' },
    { name: 'Tap & Faucet Repair', icon: '🚰' },
    { name: 'Bathroom Fitting', icon: '🚿' },
    { name: 'Water Tank Cleaning', icon: '💧' },
    { name: 'Drainage Cleaning', icon: '🪣' },
    { name: 'Geyser Installation', icon: '🔥' },
    { name: 'Leak Repair', icon: '💦' },
  ],
  'Solar Pv Technician': [
    { name: 'Solar Panel Installation', icon: '☀️' },
    { name: 'Solar Repair', icon: '🔧' },
    { name: 'Solar Battery', icon: '🔋' },
    { name: 'Solar Inverter', icon: '⚡' },
    { name: 'Rooftop Solar', icon: '🏠' },
    { name: 'Solar Water Heater', icon: '💧' },
  ],
  'Tailor': [
    { name: 'Ladies Stitching', icon: '👗' },
    { name: 'Gents Stitching', icon: '👔' },
    { name: 'Kids Stitching', icon: '👶' },
    { name: 'Alteration', icon: '✂️' },
    { name: 'Blouse Stitching', icon: '🥻' },
    { name: 'Embroidery', icon: '🧵' },
    { name: 'Bridal Wear Stitching', icon: '👰' },
  ],
  'Towing Service': [
    { name: 'Car Towing', icon: '🚗' },
    { name: 'Bike Towing', icon: '🏍️' },
    { name: 'Truck Towing', icon: '🚛' },
    { name: 'Accident Recovery', icon: '🚨' },
    { name: '24x7 Towing', icon: '🕐' },
    { name: 'Roadside Assistance', icon: '🛣️' },
  ],
};
